import React from "react";
import { Drawer } from "./Drawer";

export const DonateDrawer = ({ activeTab, setActiveTab }) => {
    return (
        <Drawer drawerId='donate' activeTab={activeTab} setActiveTab={setActiveTab}>
            <div className='flex flex-col justify-center items-center pt-10 pb-10'>
                <img
                    className='mb-4'
                    src='/assets/images/jpm-plus-donate-heart.png'
                    width='53'
                    height='35'
                    alt='Prayer'
                />
                <p className='text-sm text-center mb-4'>
                    Your donation will go toward sending the life-giving and
                    life-transforming gospel of grace to the nations. Thank you!
                </p>
                <a href='/donate' as='button' className='btn btn-primary m-auto'>
                    Donate Now
                </a>
            </div>
        </Drawer>
    );
};